'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputField } from '../input-field/input-field.tsx';
import { containsAlphaChars } from './utils.ts';
export const ACHName = t0 => {
  const $ = _c(21);
  let fieldProps;
  if ($[0] !== t0) {
    ({
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
  } else {
    fieldProps = $[1];
  }
  const {
    getValues,
    setValue
  } = useFormContext();
  const {
    name
  } = fieldProps;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["checkout", "payment-methods"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("payment-methods:ach.fields.name");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getValues || $[6] !== name || $[7] !== setValue) {
    t3 = () => {
      setValue(name, getValues(name).trim(), {
        shouldValidate: true
      });
    };
    $[5] = getValues;
    $[6] = name;
    $[7] = setValue;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("checkout:form.billingFields.nameOnAccountNumberError");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = {
      message: t4
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = value => containsAlphaChars(value) || t("checkout:form.ach.nameInvalid");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== fieldProps || $[16] !== t2 || $[17] !== t3 || $[18] !== t5 || $[19] !== t6) {
    t7 = <InputField autoComplete="off" label={t2} onBlur={t3} removeCardNumbers={t5} validate={t6} {...fieldProps} />;
    $[15] = fieldProps;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};